import { useCallback, useMemo } from 'react';
import { isStock } from 'modules/user-has-permission/user-has-permission';

export function usePreparationOrderDetailTableData(preparationOrder) {
  const userIsStock = useMemo(() => isStock(), []);

  const getPendingLabels = useCallback(
    (ean) => ({
      carrier: preparationOrder?.counter?.[ean] || 0,
      external:
        preparationOrder?.labels.filter(
          (label) => label.ean === ean && !!label?.external_label_id,
        )?.length || 0,
    }),
    [preparationOrder],
  );

  return useMemo(() => {
    return preparationOrder?.table?.reduce((accumulator, row) => {
      return userIsStock && !getPendingLabels(row.ean)
        ? [...accumulator]
        : [
            ...accumulator,
            {
              ...row,
              pendingLabels: getPendingLabels(row.ean).carrier,
              pendingExternalLabels: getPendingLabels(row.ean).external,
            },
          ];
    }, []);
  }, [preparationOrder, userIsStock, getPendingLabels]);
}
